var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unsubscribe"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"unsubscribe__title"},[_vm._v("Благодарим за обращение!")]),_c('p',{staticClass:"unsubscribe__description"},[_vm._v(" Наш оператор свяжется с Вами в ближайшее время ")])])])
}]

export { render, staticRenderFns }